<template>
    <div id="app" v-cloak>
        <div>
            <div class="loader" v-if="$store.state.loaders">
                <vue-loaders-ball-clip-rotate-multiple color="white" scale="1"></vue-loaders-ball-clip-rotate-multiple>
            </div>
            <router-view v-wechat-title="$route.meta.title"></router-view>
            <foot-nav v-if="$store.state.isShowNavSetting"></foot-nav>
        </div>
    </div>
</template>


<script>
    import footNav from "@/components/FootNav";
    export default {
        name: 'app',
        components: {
            'foot-nav': footNav,
        },
        data() {
            return {

            }
        },

        created() {
            // 禁止页面缩放
            document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
        },


        watch: {
            '$route': 'fetchRoute'
        },


        methods: {
            fetchRoute() {

                const arr = ['Catalog', 'Product', 'Profile', 'Merchant', 'Business', 'MarketingService',
                    'Acc', 'Goods', 'AccMerchant', 'Supplier', 'Marketing', 'TitleSet', 'Store',
                    'CommentAward', 'CarGrade', 'AccSpec', 'Activity', 'MainPage', 'AddAwards', 'Category', 'Goods02', 'Goods03', 'MarketingSort','VehicleArchives','VehiclePrice','Ledger'];

                console.log('curr-->：', this.$route.name, 'isShow-->', arr.some(x => x === this.$route.name))

                if (arr.some(x => x === this.$route.name)) {
                    this.$store.commit('setSettingNav', true);
                } else {
                    this.$store.commit('setSettingNav', false);
                }
            },
        }


    }
</script>

<style lang="scss">

    @import "https://zh-cll.oss-accelerate.aliyuncs.com/static/lib/bootstrap/dist/css/bootstrap.css";
    @import "//at.alicdn.com/t/c/font_2286320_lpjywcp60b.css"; // 阿里图标库
    //@import '@/styles/basics.scss';        // 一些基础公共样式

</style>
